import { Box, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import React from 'react';
import { Card } from '../card';
export const UserCard = (props)=>{
    const { bio , givenName , image , logos =[] , jobTitle , size , surname , ...cardProps } = props;
    const isSmall = size === 'xs';
    const sizes = isSmall ? {
        avatar: 24,
        px: 1,
        text: 'xlBold'
    } : {
        avatar: 40,
        px: 2,
        text: '2xl'
    };
    return /*#__PURE__*/ React.createElement(Card, {
        alignItems: "center",
        gap: 2,
        px: sizes.px,
        py: 3,
        size: size,
        textAlign: "center",
        ...cardProps
    }, /*#__PURE__*/ React.createElement(Box, {
        as: "figure",
        borderRadius: "full",
        boxSize: sizes.avatar,
        overflow: "hidden"
    }, image), /*#__PURE__*/ React.createElement(VStack, {
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Text, {
        as: "h3",
        textStyle: sizes.text
    }, /*#__PURE__*/ React.createElement(Text, {
        as: "span",
        display: "block",
        noOfLines: 1
    }, givenName), surname && /*#__PURE__*/ React.createElement(Text, {
        as: "span",
        display: "block",
        noOfLines: 1
    }, surname)), /*#__PURE__*/ React.createElement(Text, {
        color: "text.secondary",
        noOfLines: 3,
        textStyle: "xsBold",
        textTransform: "uppercase"
    }, jobTitle), bio && /*#__PURE__*/ React.createElement(Text, {
        color: "text.secondary"
    }, bio)), !isSmall && logos.length > 0 && /*#__PURE__*/ React.createElement(Wrap, {
        align: "center",
        justify: "center",
        spacing: 1
    }, logos.map((logo, index)=>/*#__PURE__*/ React.createElement(WrapItem, {
            key: logo.key ?? `logo-${index}`
        }, logo))));
};

//# sourceMappingURL=user-card.js.map